export default __webpack_public_path__ + "static/media/midasi_entry_zh_tw_pc@2x.099ef32e.png";